function getArrayFromQueryParam(qp: string) {
  if (!qp) return [];

  return qp?.split(",")?.filter((value) => value!!) || [];
}

export default getArrayFromQueryParam;
